import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-12fddde6")

_pushScopeId("data-v-12fddde6")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "学習室作成", -1)
const _hoisted_4 = { class: "flex-grow flex flex-col items-center bg-primary-100 overflow-y-scroll pt-12" }
const _hoisted_5 = { class: "panel-container rounded-md bg-white pb-2 mb-16 lg:mb-8" }
const _hoisted_6 = { class: "flex items-center justify-between w-full table-header-color px-4 py-3" }
const _hoisted_7 = { class: "mr-2" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm" }, "開室予約取得中...", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_loading_icon = _resolveComponent("m-loading-icon")
  const _component_m_table = _resolveComponent("m-table")
  const _component_mr_add_modal = _resolveComponent("mr-add-modal")
  const _component_mr_edit_room_reservation_modal = _resolveComponent("mr-edit-room-reservation-modal")
  const _component_mr_edit_room_regularly_reservation_modal = _resolveComponent("mr-edit-room-regularly-reservation-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_MNavBar),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_MHeaderPanel, {
          title: "学習室情報",
          breadcrumbs: [],
          tabs: _ctx.tabs,
          "current-tab-index": _ctx.currentTabIndex
        }, _createSlots({ _: 2 }, [
          (_ctx.isAdmin || _ctx.allowCreateRoom)
            ? {
                name: "actions",
                fn: _withId(() => [
                  _createVNode(_component_m_button, {
                    color: "secondary-500",
                    "hover-color": "secondary-600",
                    outline: "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDisplayedAddRoomModal = true))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_m_icon, {
                        type: "plus",
                        width: "3",
                        class: "mr-2 transform rotate-90 z-0"
                      }),
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ])
              }
            : undefined
        ]), 1032, ["tabs", "current-tab-index"]),
        _createVNode("main", _hoisted_4, [
          _createVNode("section", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchKeyword = $event)),
                  type: "search",
                  name: "searchRoom",
                  placeholder: "学習室名で検索...",
                  class: "w-60 bg-white rounded border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
                }, null, 512), [
                  [_vModelText, _ctx.searchKeyword]
                ])
              ])
            ]),
            (_ctx.load)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode(_component_m_loading_icon),
                  _hoisted_9
                ]))
              : (_openBlock(), _createBlock(_component_m_table, {
                  key: 1,
                  datas: _ctx.filteredDatas,
                  definitions: _ctx.definitions,
                  "default-sort-key": "time",
                  editable: _ctx.isAdmin,
                  onSelect: _ctx.showEditModal
                }, null, 8, ["datas", "definitions", "editable", "onSelect"]))
          ])
        ])
      ])
    ]),
    ((_ctx.isAdmin || _ctx.allowCreateRoom) && _ctx.isDisplayedAddRoomModal)
      ? (_openBlock(), _createBlock(_component_mr_add_modal, {
          key: 0,
          school: _ctx.school,
          groups: _ctx.groups,
          targets: _ctx.targets,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDisplayedAddRoomModal = false))
        }, null, 8, ["school", "groups", "targets"]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin && _ctx.isDisplayedEditReservationModal && _ctx.selectedRoomReservation)
      ? (_openBlock(), _createBlock(_component_mr_edit_room_reservation_modal, {
          key: 1,
          "room-reservation": _ctx.selectedRoomReservation,
          groups: _ctx.groups,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDisplayedEditReservationModal = false))
        }, null, 8, ["room-reservation", "groups"]))
      : _createCommentVNode("", true),
    (
      _ctx.isAdmin &&
        _ctx.isDisplayedEditRegularlyReservationModal &&
        _ctx.selectedRoomRegularlyReservation
    )
      ? (_openBlock(), _createBlock(_component_mr_edit_room_regularly_reservation_modal, {
          key: 2,
          "room-regularly-reservation": _ctx.selectedRoomRegularlyReservation,
          groups: _ctx.groups,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isDisplayedEditRegularlyReservationModal = false))
        }, null, 8, ["room-regularly-reservation", "groups"]))
      : _createCommentVNode("", true)
  ], 64))
})